import { createStore, combineReducers, applyMiddleware } from "redux";
// import thunk from "redux-thunk";
import { thunk } from "redux-thunk";

import userReducer from "../Reducers/userReducer";
import sidebarReducer from "../Reducers/sidebarReducer";
import taskReducer from "../Reducers/taskReducer";
import checkinReducer from "../Reducers/switchReducer"; 

import formfillReducer from "../Reducers/formfillReducer";


const rootReducer = combineReducers({
  sidebar: sidebarReducer,
  user: userReducer,
  tasks: taskReducer,
  checkin: checkinReducer, 

  form:formfillReducer
});

const store = createStore(rootReducer, applyMiddleware(thunk));

export default store;
